import "core-js/modules/es.number.constructor.js";
//
//
//
//

export default {
  name: 'widget__mask',
  props: {
    maskOpacity: {
      // 蒙层透明度
      type: Number,
      default: 0.4
    }
  },
  mounted: function mounted() {
    var cssStr = 'overflow-y: hidden; height: 100%;';
    document.getElementsByTagName('body')[0].style.cssText = cssStr;
    document.body.style.cssText = cssStr;
  },
  destroyed: function destroyed() {
    var cssStr = 'overflow-y: auto; height: auto;';
    document.getElementsByTagName('body')[0].style.cssText = cssStr;
    document.body.style.cssText = cssStr;
  },
  methods: {
    triggerClick: function triggerClick() {
      this.$emit('click');
    }
  }
};